import '../../index.css';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

export default class Help extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div
        className="index"
        style={{
          display: 'flex',
          paddingTop: '100px',
          justifyContent: 'center',
        }}
      >
        <Helmet>
          <meta
            name="description"
            content="DeWaste is the easiest way to quickly and reliably reduce food waste. Using image analysis, we can give you accurate wastage data instantly."
          />

          <meta
            itemProp="name"
            content="DeWaste | Food Waste Analysis for all dining institutions"
          />
          <meta
            itemProp="description"
            content="DeWaste is the easiest way to quickly and reliably reduce food waste. Using image analysis, we can give you accurate wastage data instantly."
          />
          <meta itemProp="image" content="https://de-waste.com/logo.png" />

          <meta property="og:image" content="https://de-waste.com/logo.png" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="DeWaste" />
          <meta
            property="og:description"
            content="DeWaste is the easiest way to quickly and reliably reduce food waste. Using image analysis, we can give you accurate wastage data instantly."
          />
          <meta property="og:site_name" content="DeWaste" />
          <meta property="og:url" content="https://de-waste.com" />

          <meta name="twitter:card" content="summary" />
          <meta name="twitter:image" content="https://de-waste.com/logo.png" />
          <meta name="twitter:title" content="DeWaste" />
          <meta
            name="twitter:description"
            content="DeWaste is the easiest way to quickly and reliably reduce food waste. Using image analysis, we can give you accurate wastage data instantly."
          />
        </Helmet>

        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSdjfd68Nk-u_jcnFcpJBpV78f2NapOFmHRJigWwOacU8U9KFw/viewform?embedded=true"
          width="640"
          height="690"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          title="helpFormDashboard"
        >
          Loading…
        </iframe>
      </div>
    );
  }
}
